import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Loading } from '@/components/ui';

export function PublicRoute() {
  const { user, isInitialized } = useAuthStore();
  const location = useLocation();

  // Show loading only during initial auth state check
  if (!isInitialized) {
    return <Loading fullScreen message="読み込み中..." />;
  }

  // Redirect to dashboard if already authenticated
  if (user && user.emailVerified) {
    const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  // Redirect to verify email if authenticated but not verified
  if (user && !user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
